<div class="search-header">
  <div class="header-container">
    <forge-icon-button class="back-btn" (click)="goBack()" (keydown.enter)="goBack()" aria-label="Go back to landing page">
      <forge-icon name="arrow_back"></forge-icon>
    </forge-icon-button>
    <h1 class="search-title forge-typography--heading3">Search results</h1>
  </div>
</div>
<instance-header></instance-header>
<div class="search-page container">
  <div class="search-box" #searchBox>
    <forge-card raised="true" class="search-card">
      <div class="search-container">
        <div class="search-input-wrapper">
          <forge-text-field style="width: 100%" label-position="block-start">
            <label for="public-search-input">Search for inmates</label>
            <forge-icon name="search" slot="leading"></forge-icon>
            <input id="public-search-input" type="text" [(ngModel)]="searchModel.nameOrId" (input)="onInput()" (keyup.enter)="onSearch()"
              placeholder="Search by name or ID number" aria-label="Search by name or ID number" spellcheck="false" />
            @if (searchModel.nameOrId) {
              <forge-icon-button slot="trailing" (click)="clearSearch()" aria-label="Clear search">
                <forge-icon name="close"></forge-icon>
              </forge-icon-button>
            }
          </forge-text-field>
          @if (isDocSearch) {
            <div class="alias-checkbox-container">
              <forge-checkbox
                [(ngModel)]="searchModel.searchAlias"
                id="public-search-alias-checkbox">
                Search Alias Names
              </forge-checkbox>
            </div>
          }
        </div>
        <div class="button-group">
          <forge-button variant="raised" [disabled]="isSearchDisabled()" (click)="onSearch()" aria-label="Search"> Search
          </forge-button>
          @if (showAdvancedSearch) {
            <forge-button variant="text" class="advanced-search-button" (click)="onAdvancedSearch()" aria-label="Advanced search">
              Advanced search{{ getAdvancedFilterCount(searchParamChips$ | async) > 0 ? ' (' + getAdvancedFilterCount(searchParamChips$ | async) + ')' : '' }}
            </forge-button>
          }
        </div>
      </div>

    </forge-card>
  </div>
  <div class="top-card" [ngClass]="{'doc-top-card': isDocSearch}">
    @if (isDocSearch) {
      <div class="warning-banner-container">
        <forge-inline-message theme="warning">
          <forge-icon name="alert" slot="icon"></forge-icon>
          Unauthorized use of this site's information to harass or target individuals is a criminal offense.
        </forge-inline-message>
      </div>
      <div class="table-info doc-table-info">
        <forge-select class="doc-sort-select" variant="outlined" label="Sort by" aria-label="Sort by"
          [ngModel]="docSortBy" (ngModelChange)="onDocSortChange($event)">
          @for (option of docSortOptions; track option.value) {
            <forge-option [value]="option.value">{{ option.label }}</forge-option>
          }
        </forge-select>
      </div>
    }
    @if (!isDocSearch) {
    <div class="table-info">
      <div>
        <span class="title">All current inmates</span>
        <span class="info" *ngIf="updatedAt$ | async as updatedAt else loadingUpdatedAt">
          Updated: {{updatedAt | date: 'MMMM dd, yyyy @ h:mm a' | na }}
        </span>
      </div>
      <forge-button variant="outlined" (click)="onSortOrFilterClick()" aria-label="Sort or Filter">
        <forge-icon name="sort" slot="start"></forge-icon>
        Sort or Filter
      </forge-button>
    </div>
    }
    <div class="search-chips">
      <forge-chip-set [ngClass]="{'limit-chips': isMobile && allChipsShowingMobile === false}" #chipset>
        @for(chip of searchParamChips$ | async; track chip.orderAdded) {
        @if(chip.key === 'dateRange') {
        <forge-chip #chipElement>Arrest Date: {{getLastNDaysLabel(chip.value) | camelToNormal }}
          <forge-icon name="close" slot="end" tabindex="0" role="button" aria-label="Remove filter" (click)="onRemoveChip($event, chip)" (keydown.enter)="onRemoveChip($event, chip)" (keydown.space)="onRemoveChip($event, chip)"></forge-icon>
        </forge-chip>
        }@else if (chip.key === 'arrestingAgencies') {
        <forge-chip #chipElement>Arresting Agency: {{chip.value | camelToNormal }}
          <forge-icon name="close" slot="end" tabindex="0" role="button" aria-label="Remove filter" (click)="onRemoveChip($event, chip)" (keydown.enter)="onRemoveChip($event, chip)" (keydown.space)="onRemoveChip($event, chip)"></forge-icon>
        </forge-chip>
        }@else if (isDateChip(chip.key)) {
        <forge-chip #chipElement>{{ chip.key | camelToNormal }}: {{ getDateLabel(chip.value) }}
          <forge-icon name="close" slot="end" tabindex="0" role="button" aria-label="Remove filter" (click)="onRemoveChip($event, chip)" (keydown.enter)="onRemoveChip($event, chip)" (keydown.space)="onRemoveChip($event, chip)"></forge-icon>
        </forge-chip>
        }@else if (chip.key === 'minAge' || chip.key === 'maxAge') {
        <forge-chip #chipElement>{{ chip.key | camelToNormal }}: {{ chip.value }}
          <forge-icon name="close" slot="end" tabindex="0" role="button" aria-label="Remove filter" (click)="onRemoveChip($event, chip)" (keydown.enter)="onRemoveChip($event, chip)" (keydown.space)="onRemoveChip($event, chip)"></forge-icon>
        </forge-chip>
        }
        @else {
        <forge-chip #chipElement>{{ chip.key | camelToNormal }}: {{ getOptionLabel(chip.key, chip.value) }}
          <forge-icon name="close" slot="end" tabindex="0" role="button" aria-label="Remove filter" (click)="onRemoveChip($event, chip)" (keydown.enter)="onRemoveChip($event, chip)" (keydown.space)="onRemoveChip($event, chip)"></forge-icon>
        </forge-chip>
        }
        }
      </forge-chip-set>
      @if(isMobile && hiddenChips > 0) {
      <forge-button class='expand-button' variant="text" type="button" aria-label="Show More/Hide"
        (click)="toggleShowAllChips()">
        <forge-icon name="{{!allChipsShowingMobile ? 'expand_more' : 'expand_less'}}" slot="end"></forge-icon>
        {{!allChipsShowingMobile ? hiddenChips + ' More' : 'Hide'}}
      </forge-button>
      }
    </div>

    <div class="result-counter">{{ inmates.length }} Result{{ inmates.length !== 1 ? 's' : '' }}</div>
  </div>
  <div class="result-container" [ngClass]="{'doc-result-container': isDocSearch}">
    @if (!isDocSearch) {
      <div class="table-header">
        <div class="header-cell header-image"></div>
        <div class="header-cell header-name">Name / ID</div>
        <div class="header-cell header-arrest-date">Date / time arrested</div>
        <div class="header-cell header-age">Age</div>
        <div class="header-cell header-arresting-agency">Arresting Agency</div>
        <div class="header-cell header-actions"></div>
      </div>
      @if (inmates.length > 0) {
        @for (inmate of inmates; track $index) {
          <inmate-card [inmate]="inmate" (click)="onPersonClick(inmate)"></inmate-card>
        }
      }
      @else {
        <search-state [loading]="loading"></search-state>
      }
    } @else {
      <div class="doc-table-header">
        <div class="doc-header-cell doc-header-name">Name / PID</div>
        <div class="doc-header-cell doc-header-facility">Current facility</div>
        <div class="doc-header-cell doc-header-status"></div>
      </div>
      @if (inmates.length > 0) {
        @for (inmate of inmates; track $index) {
          <doc-inmate-card [inmate]="inmate" (click)="onPersonClick(inmate)"></doc-inmate-card>
        }
      }
      @else {
        <search-state [loading]="loading"></search-state>
      }
    }
  </div>
  @if (inmates.length > 0) {
  <div class="pagination-section">
    <div class="pagination-info">{{ inmates.length }} of {{ pagination?.total }} results displayed</div>
    <forge-button variant="outlined" aria-label="Load more results" (click)="loadInmates()"
      [disabled]="pagination?.total === inmates.length">Load more results</forge-button>
    <forge-button variant="text" aria-label="Back to top" (click)="scrollToTop()"><forge-icon
        name="arrow_up_drop_circle" slot="start"></forge-icon>Back to top</forge-button>
  </div>
  }
</div>

<ng-template #loadingUpdatedAt>
  <forge-skeleton text class="updatedAt-skeleton"></forge-skeleton>
</ng-template>